import { ALIGN_MAPPING } from "../constanst";
import { getPaddingString, toRGBA } from "../parser/utils";

export const getFinalUrl = (data) => {
  if (data.linkUrlType === "web") {
    return data.linkUrl;
  } else if (data.linkUrlType === "landing") {
    return data.landingPage;
  } else if (data.linkUrlType === "email") {
    return `mailto:${data.email}?subject=${encodeURIComponent(data.emailSubject || "")}&body=${encodeURIComponent(data.emailBody || "")}`;
  } else if (data.linkUrlType === "phone") {
    return `tel:${data.phone || ""}`;
  } else if (data.linkUrlType === "anchor") {
    return `#${data.linkAnchor}`;
  }
  return data.linkUrl;
}

export default ({ data, id }) => {
  const {
    paddingTop = 10,
    paddingBottom = 10,
    paddingRight = 0,
    paddingLeft = 0,
    borderWidth,
    borderColor = {},
    borderStyle,
    borderRadius,
    shadowSize = 0,
    shadowDirection = 0,
    shadowBlur = 0,
    shadowColor = {},
    autoWidth = true,
    contentID,
    width = 100,
    alt = "Ri+",
    linkNewTab = false,
    linkUrlType,
    align = "center",
    url,
  } = data;


  const oneDeg = (Math.PI * 2) / 360;
  const revertDeg = 360 - shadowDirection;
  const x = Math.sin(revertDeg * oneDeg) * shadowSize;
  const y = Math.cos(revertDeg * oneDeg) * shadowSize;
  const xShadow = x.toFixed(0);
  const yShadow = y.toFixed(0);

  const finalUrl = getFinalUrl(data);

  let imageHtml;
  if (finalUrl) {
    imageHtml = `<a target="${linkNewTab? '_target': '_self'}" href="${finalUrl}" data-link-type="${linkUrlType}" style="display: inline-block;width: ${autoWidth ? 'auto': width+'%'};line-height:0;">
                    <img
                      alt="${alt}"
                      style="width:100%;max-width: 100%"
                      src="${url}"
                    />
                  </a>`;
  } else {
    imageHtml = `<img
                  alt="${alt}"
                  style="width: ${autoWidth ? 'auto': width+'%'}; max-width: 100%"
                  src="${url}"
                />`;
  }

  return `
    <div
      id="${contentID || id}"
      style="${getPaddingString(data)} border-color: ${toRGBA(borderColor)};
        border-style: ${borderStyle};
        border-width: ${borderWidth || 0}px;
        border-radius: ${borderRadius || 0}px;
        box-shadow: ${xShadow}px ${yShadow}px ${shadowBlur}px ${toRGBA(shadowColor)};
        paddingTop: ${paddingTop};
        paddingBottom: ${paddingBottom};
        paddingLeft: ${paddingLeft};
        paddingRight: ${paddingRight};
        display:flex;
        justify-content: ${ALIGN_MAPPING[align]};
      "
    >
      ${imageHtml}
    </div>
  `;
};


